import { render, staticRenderFns } from "./enforcement.vue?vue&type=template&id=765bfa8e&scoped=true&"
import script from "./enforcement.vue?vue&type=script&lang=js&"
export * from "./enforcement.vue?vue&type=script&lang=js&"
import style0 from "./enforcement.vue?vue&type=style&index=0&id=765bfa8e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765bfa8e",
  null
  
)

export default component.exports